export interface RateEntry {
  postType: string;
  minAmount: number | null;
  maxAmount: number | null;
}

export interface SocialProfile {
  platform: string;
  handle: string;
  followerRange: string;
  rates: RateEntry[];
  noRatesYet: boolean;
  contentLinks: string[];
}

export interface CreatorApplication {
  fullName: string;
  mobile: string;
  email: string;
  ageRange: string;
  gender: string;
  city: string;
  stateRegion: string;
  occupation: string;
  occupationOther: string;
  languages: string[];
  languagesOther: string;

  socialProfiles: SocialProfile[];

  interests: string[];
  interestsOther: string;
  styles: string[];
  showFace: boolean | null;
  ugcOnly: boolean | null;

  campaignTypes: string[];
  compensation: string;
  attendEvents: boolean | null;
  areas: string[];
  areasOther: string;

  whyJoin: string;
  howDidYouHearAboutUs: string;
  howDidYouHearAboutUsOther: string;
  referralCode: string;
  consentContact: boolean;
  consentPdpa: boolean;
}

export const EMPTY_SOCIAL_PROFILE: SocialProfile = {
  platform: "",
  handle: "",
  followerRange: "",
  rates: [],
  noRatesYet: false,
  contentLinks: [],
};

export const EMPTY_APPLICATION: CreatorApplication = {
  fullName: "",
  mobile: "",
  email: "",
  ageRange: "",
  gender: "",
  city: "",
  stateRegion: "",
  occupation: "",
  occupationOther: "",
  languages: [],
  languagesOther: "",

  socialProfiles: [],

  interests: [],
  interestsOther: "",
  styles: [],
  showFace: null,
  ugcOnly: null,

  campaignTypes: [],
  compensation: "",
  attendEvents: null,
  areas: [],
  areasOther: "",

  whyJoin: "",
  howDidYouHearAboutUs: "",
  howDidYouHearAboutUsOther: "",
  referralCode: "",
  consentContact: false,
  consentPdpa: false,
};
